import { createRoute } from '@tanstack/react-router';
import { tourConfigRoute } from '@/features/dashboard/tourConfig/routes/tourConfigRoutes.ts';
import TourTransportConfigPage from '@/features/dashboard/tourTransport/pages/TourTransportConfigPage.tsx';

export const tourTransportConfigRoute = createRoute({
  getParentRoute: () => tourConfigRoute,
  path: 'transport',
  component: TourTransportConfigPage,
});
